import { IconComponent } from '@shared/components/icon';
import { NavigationSidebarComponent } from '@shared/navigation-sidebar';
import { NAVIGATION_BACKSTAGE } from './core/navigation/navigation-backstage';
import { filtrerNavigation } from './core/navigation/filtrer-navigation';

import type { NavigationEntry } from '@shared/navigation-sidebar';
import { TooltipDirective } from '@shared/directives/tooltip';
import { Component, signal, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { combineLatest, tap } from 'rxjs';
import { version } from '../version.json';
import { FeatureFlags } from './feature-flags';
import { ToastContainerComponent } from '@shared/toast/presentation/toast-container.component';
import { ChargementComponent } from './partage/components/chargement/chargement.component';
import { ChargementService } from './partage/components/chargement/chargement.service';
import { ConnexionService } from './partage/components/login/connexion.service';
import { LoginComponent } from './partage/components/login/login.component';
import {
  possedeUnRoleParmi,
  RolesAcces,
  RolesUtilisateurService,
} from './partage/components/login/roles-utilisateur.service';
import { FeatureFlagService } from './partage/feature-flag/feature-flag.service';

import { FeatureFlagDirective } from './partage/feature-flag/feature-flag.directive';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NavigationSidebarComponent,
    IconComponent,
    TooltipDirective,
    RouterOutlet,
    RouterLink,
    ChargementComponent,
    LoginComponent,
    ToastContainerComponent,
    FeatureFlagDirective,
  ],
})
export class AppComponent extends ConnexionService {
  private chargementservice = inject(ChargementService);
  private featureFlagService = inject(FeatureFlagService);
  private rolesUtilisateur = inject(RolesUtilisateurService);

  version: string;

  /**
   * Entrees de navigation reellement visibles.
   *
   * La barre du kit ne connait que les droits du Manager (`SECTION_RIGHTS`) :
   * pour une route qu'elle ne repertorie pas, elle n'applique aucun filtre. Le
   * filtrage BackStage — roles Azure et drapeaux de fonctionnalite — reste donc
   * ici, comme avec l'ancien menu, et alimente l'entree `[navigation]`.
   */
  protected readonly navigationAutorisee = signal<readonly NavigationEntry[]>([]);

  /** Applique les droits BackStage a NAVIGATION_BACKSTAGE. */
  private calculerNavigation(featureFlags: Record<string, boolean>, roles: readonly string[]): void {
    this.navigationAutorisee.set(
      filtrerNavigation(NAVIGATION_BACKSTAGE, {
        accesClients: possedeUnRoleParmi(roles, RolesAcces.clients),
        accesComptabilite: possedeUnRoleParmi(roles, RolesAcces.comptabilite),
        featureFlags,
      }),
    );
  }

  isLoading() {
    return this.chargementservice.isLoading();
  }

  constructor() {
    super();
    this.version = version;

    // Le menu dépend des feature flags ET des rôles Azure de l'utilisateur :
    // Admin voit tout, Compta les menus comptables, Tech/ServiceClient le menu Clients
    combineLatest([this.featureFlagService.getFeaturesFlags(), this.rolesUtilisateur.roles$])
      .pipe(tap(([featureFlags, roles]) => this.calculerNavigation(featureFlags, roles)))
      .subscribe();
  }
  featureflagsVersion = FeatureFlags.VERSION;
}
